export type PaymentStatus =
  | 'Pending'
  | 'AwaitingCustomer'
  | 'Paid'
  | 'Failed'
  | 'Expired'
  | 'Canceled';

export type PaymentAutomationTrigger = 'paid';
export type PaymentAutomationActionType = 'conversation_message' | 'create_task';

export interface PaymentEvent {
  id: string;
  fromStatus?: string;
  toStatus: string;
  providerStatus?: string;
  note?: string;
  createdAtUtc: string;
}

export interface Payment {
  id: string;
  amount: number;
  currency: string;
  description: string;
  status: PaymentStatus;
  providerCode: string;
  checkoutUrl?: string;
  providerStatus?: string;
  contactId?: string;
  conversationId?: string;
  invoiceId?: string;
  expiresAtUtc?: string;
  paidAtUtc?: string;
  createdAtUtc: string;
  updatedAtUtc: string;
  events: PaymentEvent[];
}

export interface PaymentPagedResult {
  items: Payment[];
  page: number;
  pageSize: number;
  total: number;
  hasNext: boolean;
}

export interface PaymentListQuery {
  status?: PaymentStatus | '';
  contactId?: string;
  conversationId?: string;
  page?: number;
  pageSize?: number;
}

export interface PaymentSettings {
  enabled: boolean;
  providerCode?: string;
  hasCredentials: boolean;
  currency: string;
  language: string;
  environment: string;
  returnPath?: string;
  availableProviders: string[];
}

export interface UpdatePaymentSettingsRequest {
  enabled?: boolean;
  providerCode?: string;
  currency?: string;
  language?: string;
  environment?: string;
  returnPath?: string;
  pkcs12Base64?: string;
  pkcs12Password?: string;
  caCertificatePem?: string;
  merchantHandlerUrl?: string;
  clientHandlerUrl?: string;
}

export interface CreatePaymentRequest {
  amount: number;
  currency?: string;
  description?: string;
  contactId?: string;
  conversationId?: string;
  invoiceId?: string;
  expiresInMinutes?: number;
}

export interface SendPaymentLinkRequest {
  conversationId?: string;
  message?: string;
}

export interface PaymentAutomationRule {
  id: string;
  name: string;
  isEnabled: boolean;
  trigger: PaymentAutomationTrigger;
  actionType: PaymentAutomationActionType;
  templateText?: string;
  taskTitle?: string;
  taskDescription?: string;
  createdAtUtc: string;
  updatedAtUtc: string;
}

export interface UpsertPaymentAutomationRuleRequest {
  name?: string;
  isEnabled?: boolean;
  trigger?: PaymentAutomationTrigger;
  actionType?: PaymentAutomationActionType;
  templateText?: string;
  taskTitle?: string;
  taskDescription?: string;
}

export const PAYMENT_STATUSES: PaymentStatus[] = [
  'Pending',
  'AwaitingCustomer',
  'Paid',
  'Failed',
  'Expired',
  'Canceled',
];

export const OPEN_PAYMENT_STATUSES: PaymentStatus[] = ['Pending', 'AwaitingCustomer'];
